import ayurmaLogo from "../../images/fourSeason/ayurmaLogo.png";
import ayurmaQr from "../../images/fourSeason/ayurmaQr.png";
import { WhiteLabelTheme } from "../whiteLabelTheme";

// AyurMa — the wellness brand at Four Seasons. First white-label client.
export const fourSeasonTheme: WhiteLabelTheme = {
  customType: "fourSeason",
  companyName: "AyurMa",
  contactEmail: "wellness@ayurma.com",
  logo: ayurmaLogo,
  logoHeight: 26,
  // Client-supplied, encodes https://ayurma.life
  qrCode: ayurmaQr,
  colors: {
    primary: "#123A54",
    accentA: "#1E9C93",
    accentB: "#D6A233",
  },
  sectionMarkers: {
    yoga: "#1E9C93",
    aerobic: "#EFA33E",
    strength: "#4E8FC7",
  },
  pdfFileName: "AyurMa_Metabolic_Assessment",
};
